const onClick = e => {
  console.log(e);
  const opener = e.target.closest('.opener');
  opener && opener.classList.toggle('open');
 
};

export const cleanOpener = () => {
  const openers = document.querySelectorAll(".opener h2");
  openers.forEach(o => {
    o.removeEventListener("click", onClick);
  });
};

export const initOpener = () => {
  const openers = document.querySelectorAll(".opener h2");
 
  openers.forEach(o => {
    o.addEventListener("click", onClick);
  });
};
